document.addEventListener('DOMContentLoaded', function() {
    const body = document.body;
    const menuToggle = document.getElementById('mega-menu-toggle');
    const menuOverlay = document.getElementById('mega-menu-overlay');
    const menuClose = document.getElementById('mega-menu-close');
    const menuNavContent = document.getElementById('mega-menu-nav-content');
    const menuOpenClass = 'mega-menu-open';

    if (menuToggle && menuOverlay) {
        let scrollPosition = 0;

        function closeMenu() {
            body.classList.remove(menuOpenClass);
            const savedScrollPosition = parseInt(document.body.style.top || '0') * -1;
            
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            
            setTimeout(function() {
                window.scrollTo(0, savedScrollPosition || scrollPosition);
            }, 0);
        }

        menuToggle.addEventListener('click', function() {
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            body.classList.add(menuOpenClass);
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPosition}px`;
            document.body.style.width = '100%';
            
            menuOverlay.scrollTop = 0;
        });

        if (menuClose) {
            menuClose.addEventListener('click', closeMenu);
        }

        menuOverlay.addEventListener('click', function(e) {
            if (e.target === menuOverlay) {
                closeMenu();
            }
        });

        menuOverlay.addEventListener('wheel', function(e) {
            if (body.classList.contains(menuOpenClass)) {
                e.stopPropagation();
            }
        }, { passive: false });

        menuOverlay.addEventListener('touchmove', function(e) {
            if (body.classList.contains(menuOpenClass)) {
                e.stopPropagation();
            }
        }, { passive: false });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && body.classList.contains(menuOpenClass)) {
                closeMenu();
            }
        });
    }

    function isMobile() {
        return window.matchMedia('(max-width: 639px)').matches;
    }

    function initMenuHeaders() {
        if (!isMobile()) {
            return;
        }

        const headers = document.querySelectorAll('.mega-menu-header-has-children:not([data-mm-init])');
        headers.forEach((header) => {
            header.dataset.mmInit = '1';

            header.addEventListener('click', (e) => {
                if (!menuOverlay || !body.classList.contains(menuOpenClass)) return;

                const toggle = header.querySelector('.mega-menu-toggle');
                if (!toggle) return;

                const column = header.closest('.mega-menu-column');
                if (!column) return;

                e.preventDefault();
                e.stopPropagation();

                const children = column.querySelector('.mega-menu-children');
                if (!children) return;

                const icon = toggle.querySelector('svg');

                const raw = (toggle.getAttribute('aria-expanded') || 'false').trim().toLowerCase();
                const isExpanded = raw === 'true';

                if (isExpanded) {
                    toggle.setAttribute('aria-expanded', 'false');
                    children.classList.remove('mega-menu-expanded');
                    if (icon) icon.style.transform = 'rotate(0deg)';
                } else {
                    const allHeaders = document.querySelectorAll('.mega-menu-header-has-children[data-mm-init="1"]');
                    allHeaders.forEach((otherHeader) => {
                        if (otherHeader === header) return;
                        
                        const otherToggle = otherHeader.querySelector('.mega-menu-toggle');
                        const otherColumn = otherHeader.closest('.mega-menu-column');
                        if (!otherToggle || !otherColumn) return;
                        
                        const otherChildren = otherColumn.querySelector('.mega-menu-children');
                        const otherIcon = otherToggle.querySelector('svg');
                        
                        if (otherToggle.getAttribute('aria-expanded') === 'true') {
                            otherToggle.setAttribute('aria-expanded', 'false');
                            if (otherChildren) otherChildren.classList.remove('mega-menu-expanded');
                            if (otherIcon) otherIcon.style.transform = 'rotate(0deg)';
                        }
                    });
                    
                    toggle.setAttribute('aria-expanded', 'true');
                    children.classList.add('mega-menu-expanded');
                    if (icon) icon.style.transform = 'rotate(180deg)';
                }
            });
        });
    }

    if (menuNavContent) {
        initMenuHeaders();
    }
});